import { Add } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { useDisclosure } from '@hooks/useDisclosure';

import { StakeholderAnalysisFormValues } from '../ImpactsOnStakeholdersFormProvider/types';

import DisclosureGuidelinesStakeholderAnalysis from '@Router/ImpactsOnStakeholdersManagement/Components/DisclosureGuidelines/DisclosureGuidelinesStakeholderAnalysis';
import { useWatch } from 'react-hook-form';
import ExplanationOfBusinessValueChain from './ExplanationOfBusinessValueChain';
import ModalAddStakeholderAnalysis from './ModalAddStakeholderAnalysis';
import StakeholderAnalysisIntroduction, {
  STAKEHOLDER_ANALYSIS_INTRODUCTION_ID,
} from './StakeholderAnalysisIntroduction';
import StakeholderAnalysisRemark, {
  STAKEHOLDER_ANALYSIS_REMARK_ID,
} from './StakeholderAnalysisRemark';
import StakeholderAnalysisUploadImage from './StakeholderAnalysisUploadImage';
import StakeholderAnalysisValueChainFormCompletionCheckbox from './StakeholderAnalysValueChainFormCompletionCheckbox';
import StakeholderAnalysisTable from './TableStakeholderAnalysis/StakeholderAnalysisTable';

const StakeholderAnalysisValueChainOfBusiness = () => {
  const [openedModal, { open: openModal, close: closeModal }] = useDisclosure();

  const { completedSection } = useWatch({
    name: 'stakeholderAnalysis',
  }) as StakeholderAnalysisFormValues;

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  const handleAdd = () => {
    openModal();
  };

  return (
    <Box>
      <Box p={2} bgcolor={'white'}>
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Flex gap={1}>
            <Typography fontWeight={700}>
              การวิเคราะห์ผู้มีส่วนได้เสียในห่วงโซ่คุณค่าของธุรกิจ
            </Typography>
            <Flex gap={0.5} alignItems={'center'}>
              <StakeholderAnalysisIntroduction />
              <StakeholderAnalysisRemark />
            </Flex>
          </Flex>
          <DisclosureGuidelinesStakeholderAnalysis />
        </Flex>
        <Box id={STAKEHOLDER_ANALYSIS_INTRODUCTION_ID} />
        <Flex justifyContent={'flex-end'} mt={2}>
          <Button
            color={'inherit'}
            onClick={handleAdd}
            startIcon={<Add />}
            disabled={isCompletedTh || isCompletedEn}
          >
            เพิ่มข้อมูล
          </Button>
        </Flex>
        <StakeholderAnalysisTable />
        <StakeholderAnalysisUploadImage />
        <ExplanationOfBusinessValueChain />
        <Box id={STAKEHOLDER_ANALYSIS_REMARK_ID} />
      </Box>
      <StakeholderAnalysisValueChainFormCompletionCheckbox />
      {openedModal && (
        <ModalAddStakeholderAnalysis
          open={openedModal}
          close={closeModal}
          mode="create"
        />
      )}
    </Box>
  );
};

export default StakeholderAnalysisValueChainOfBusiness;
